import { CSSObject } from '@chakra-ui/react';

export const TakeActionWrapper: CSSObject = {
  px: '2',
  color: 'black',
};

export const BoxTakeActionTable: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 'md',
  p: '2',
  bg: 'white',
};

export const TextTakeAction: CSSObject = {
  color: 'gray.700',
  fontWeight: 'medium',
};
